import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import FormField from "../../Helpers/FormField";
import NumberField from "../../Helpers/NumberField";
import {custom, input} from "../../../utils/linker";

function String(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  return (
    <FormField title={props.option.name} description={props.option.description}>
      <input type="text" className="w100" {...input(props.linker,"value")} />
    </FormField>
  )
};

String.defaultProps = {};

String.propTypes = {}

export default observer(String);
